import React, { useState } from 'react';
import { Tab } from './style';

export const Tabs = ({ text = '', onClose, onClick, isSelect, isOpen }) => {
  return (
    <Tab title={text} shouldDisplay={isOpen} isSelect={isSelect}>
      <span onClick={onClick}>{text}</span>
      <span
        onClick={() => {
          onClose();
        }}
      >
        x
      </span>
    </Tab>
  );
};
